import { render, staticRenderFns } from "./VModalRemarkSendSuccess.vue?vue&type=template&id=0def5e50&"
import script from "./VModalRemarkSendSuccess.vue?vue&type=script&lang=ts&"
export * from "./VModalRemarkSendSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./VModalRemarkSendSuccess.vue?vue&type=style&index=0&id=0def5e50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports